import React from 'react';
//import Jumbotron from '../jumbotron/jumbotron'

export default function Error(props){
    return <div>Oops! No page found
       
    </div>

}